/**
 * Whether the browser's own `<datalist>` suggestions are usable on a text input.
 *
 * Desktop browsers and Chrome on Android show a dropdown under the field. Safari on
 * iOS shows suggestions above the keyboard and, from iOS 18, a popover whose entries
 * fill the field on tap; before iOS 18 tapping did nothing. Firefox on Android has no
 * dropdown at all. Where the native path is broken the app draws its own chips.
 */
export function nativeDatalistWorks(userAgent: string): boolean {
  const ios = /(?:iPhone|iPad|iPod)[^)]*? OS (\d+)_/.exec(userAgent);
  if (ios) return Number(ios[1]) >= 18;
  if (/Android/.test(userAgent) && /Firefox\//.test(userAgent)) return false;
  return true;
}
